import { useQuery } from '@tanstack/react-query';
import { bffApiClient } from './client';

/**
 * Event print template view model.
 * Matches backend EventPrintTemplateViewModel.
 */
export type EventPrintTemplateViewModel = {
  templateName: string;
  templateType: string;
  templateDescription?: string | null;
};

const EVENT_PRINT_TEMPLATES_QUERY_KEY = 'eventPrintTemplates';

/**
 * Fetches certificate templates from the Scales API.
 * Returns templates from EVENTPRINTTEMPLATE where TEMPLATE_TYPE = 'CERTIFICATES'.
 */
export const useCertificateTemplates = (enabled = true) => {
  return useQuery<EventPrintTemplateViewModel[], Error>({
    queryKey: [EVENT_PRINT_TEMPLATES_QUERY_KEY, 'certificates'],
    queryFn: async () => {
      const response = await bffApiClient.get<EventPrintTemplateViewModel[]>(
        '/api/event-print-templates/certificates'
      );
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes - templates rarely change
    gcTime: 10 * 60 * 1000 // 10 minutes
  });
};
